module.exports = __webpack_public_path__ + "static/media/20.ede5e568.jpg";